import { render, staticRenderFns } from "./billDetail.vue?vue&type=template&id=c756b456&scoped=true"
import script from "./billDetail.vue?vue&type=script&lang=ts"
export * from "./billDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c756b456",
  null
  
)

export default component.exports